import styled from 'styled-components';
import OfferBox from '../box';

export const FormContainer = styled(OfferBox)`
  padding: 20px;
  s-col {
    padding 15px 0;
  }
`;
